import TabContext from "@mui/lab/TabContext";
import TabList from "@mui/lab/TabList";
import TabPanel from "@mui/lab/TabPanel";
import { Box, Tab } from "@mui/material";
import { useEffect, useState } from "react";
import Base from "../../../Base/views/Base";
import ATSGenerateInvoice from "./ATSGenerateInvoice";
import ClosedInvoiceTab from "./ClosedInvoiceTab";
import { useDispatch } from "react-redux";
import { GetLetterHeadAction } from "../../../../../store/Ancillary/LetterHead/Action";
import { GetATSModuleFeaturesAction } from "../../../../../store/RoleAccess/ATSModuleFeatures/Action";
import { GetCompanyConfigurationAction } from "../../../../../store/Ancillary/CompanyDetails/Action";

const AtsInvoiceTabs = () => {
  const dispatch = useDispatch();
  const [value, setValue] = useState("1");
  const handleChange = (event, newValue) => {
    setValue(newValue);
  };
  useEffect(() => {
    dispatch(GetLetterHeadAction());
    dispatch(GetATSModuleFeaturesAction({ module_name: "ATS Invoice" }));
    dispatch(GetCompanyConfigurationAction());
  }, [dispatch]);

  return (
    <Base>
      <Box
        sx={{
          minHeight: "calc(100vh - 65px)",
          maxHeight: "calc(100vh - 65px)",
          overflow: "hidden",
        }}
      >
        <TabContext value={value}>
          <Box>
            <TabList
              sx={{
                minHeight: "40px",
                ".MuiTab-root": { minHeight: "20px" },
                "& .MuiTabs-indicator": {
                  width: "100%",
                  display: "flex",
                  justifyContent: "center !important",
                },
              }}
              onChange={handleChange}
              aria-label="lab API tabs example"
            >
              <Tab label="Active Invoice" value="1" />
              <Tab label="Closed Invoice" value="2" />
            </TabList>
          </Box>

          <TabPanel value="1" sx={{ padding: "0px" }}>
            <ATSGenerateInvoice />
          </TabPanel>
          <TabPanel value="2" sx={{ padding: "0px" }}>
            <ClosedInvoiceTab />
          </TabPanel>
        </TabContext>
      </Box>
    </Base>
  );
};

export default AtsInvoiceTabs;
